export default {
  state: {
    project: {}, // 项目
    userinfo: {}, // 用户信息
    batch: {}, // 卡断
    address: {},  // 地址
    report_authorize: null, // 是否授权,
    phyExPeoList:[],//体检人列表
    allUserMsg:{},//获取登录用户所有的信息
    reimbursementInfo: {},// 在线报销信息
    DeclarantInfo: {}, // 申报人信息
    reimbursementSuccess: {}, // 报销成功信息
    invoiceInfo: {}, // 报销单信息
  },
  mutations: {
    setProject(state,params) {
      state.project = params
    },
    setUserInfo(state,params) {
      state.userInfo = params
    },
    setBatch(state,params) {
      state.batch = params.data
    },
    setAddress(state,params) {
      state.address = params
    },
    setReportAuthorize(state, params) {
      state.report_authorize = params
    },
    reimbursementInfo(state, params) {
      state.reimbursementInfo = params;
    },
    DeclarantInfo(state, params) {
      state.DeclarantInfo = params;
    },
    reimbursementSuccess(state, params) {
      state.reimbursementSuccess = params;
    },
    invoiceInfo(state, params) {
      state.invoiceInfo = params;
    },
  },
  getters: {},
  actions: {}
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js